<template>
  <li class="menu-item">
    <a href="#" @click.stop="click" :class="playing ? 'active' : ''"><i class="icon-sound"></i></a>
    <ul class="sub-menu-items player" :class="playerClass" ref="submenu">
      <li class="seek">
        <div class="audio-name" :title="audioName">{{ audioName }}</div>
        <div class="audio-progress" ref="audioProgress" @mousemove="hover" @mouseout="hover" @click="seekClick">
          <div class="progress" ref="progress" :style="progressStyle"></div>
          <div class="progress-hover" ref="progressHover"></div>
        </div>
      </li>
      <li class="sub-menu-item"><a href="#" class="disabled" @click.prevent="stop"><t-icon name="icon-stop" alt="Stopp"/></a></li>
      <li class="sub-menu-item"><a href="#" title="Spol 15 sekunder tilbake" @click.prevent="setSeek(seek - 15)"><t-icon name="icon-backward-audio"/></a></li>
      <li class="sub-menu-item"><a href="#" @click.prevent="togglePlayback"><t-icon :name="playIcon"/></a></li>
      <li class="sub-menu-item"><a href="#" title="Spol 15 sekunder frem" @click.prevent="setSeek(seek + 15)"><t-icon name="icon-forward-audio"/></a></li>
      <li class="sub-menu-item"><a href="#" @click.prevent="click"><t-icon name="icon-sound"/></a></li>
    </ul>
    <MenuAudioPlayer v-if="sources.length" @load="loaded" ref="player" @progress="updateProgress" @play="playing = true" @stop="playing = false" :sources="sources" :formats="formats" />
  </li>
</template>

<script>
import MenuAudioPlayer from './MenuAudioPlayer'
import uiUtil from '@/utils/ui'
import { mapGetters, mapActions } from 'vuex'
import { assetApi } from 'api'

export default {
  data () {
    return {
      open: false,
      playing: false,
      progress: 0,
      sources: [],
      loading: false
    }
  },
  created () {
    document.addEventListener('click', this.clickoutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.clickoutside)
  },
  mounted () {
    this.setSources()
  },
  methods: {
    click (event) {
      event.preventDefault()
      this.open = !this.open
    },
    ...mapActions(['toggleSpinner']),
    ...mapActions('audio', ['setPlaying']),
    togglePlayback () {
      this.$refs.player.togglePlayback()
    },
    stop () {
      this.$refs.player.stop()
    },
    setSeek (seek) {
      this.$refs.player.setSeek(seek)
    },
    updateProgress (progress) {
      this.progress = progress
    },
    hover (event) {
      var width = 0
      if (event.type === 'mousemove' && this.selected !== null) {
        var fullWidth = this.$refs.audioProgress.offsetWidth
        var hoverPos = event.offsetX
        width = `${(hoverPos / fullWidth) * 100}%`
      }
      this.$refs.progressHover.style.width = width
    },
    seekClick (event) {
      var fullWidth = this.$refs.audioProgress.offsetWidth
      var clicked = event.offsetX

      var progress = (clicked / fullWidth)

      this.setProgress(progress)
    },
    setProgress (progress) {
      this.$refs.player.setProgress(progress)
    },
    setSources () {
      if (this.selected !== null) {
        this.loading = true
      }
      this.sources = this.selected !== null ? [ assetApi.getStreamUrl(this.selected.assetUrlPath) ] : []
    },
    loaded () {
      this.loading = false
    },
    clickoutside (event) {
      uiUtil.clickOutside(event, this.$refs.submenu, clickOutside => {
        if (this.open && clickOutside) {
          this.open = false
        }
      })
    }
  },
  computed: {
    ...mapGetters('audio', ['selected']),
    formats () {
      return this.selected !== null ? [ 'mp3' ] : []
    },
    playIcon () {
      return this.playing ? 'icon-pause' : 'icon-play'
    },
    seek () {
      return this.$refs.player !== undefined ? this.$refs.player.seek : 0
    },
    progressStyle () {
      return {
        width: `${Number.parseFloat(this.progress * 100)}%`
      }
    },
    playerClass () {
      var className = ''
      if (!this.sources.length) {
        className = 'disabled'
      }

      return className
    },
    audioName () {
      return this.selected != null ? this.selected.name : ''
    }
  },
  components: {
    MenuAudioPlayer
  },
  watch: {
    open () {
      this.$el.classList.toggle('open')
    },
    playing (val) {
      this.setPlaying(val)
    },
    selected (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setSources()
        this.loading = true
      }
    }
  }
}
</script>

<style lang="scss">
  $lightgreen: #00FFCE;
  .menu-item {
    .player {
      width: 425px;
      display: none;
    }
    &.open {
      .player {
        display: block;
        &.disabled {
          a {
            opacity: .5;
            pointer-events: none;
          }
          .seek {
            pointer-events: none;
          }
        }
      }
    }
    .seek {
      flex-basis: 150px;
      padding-left: 10px;
      .audio-name {
        color: #FFF;
        font-size: 0.6em;
        text-align: left;
        width: 130px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 14px;
        margin-top: 4px;
        margin-bottom: 4px;
      }
      .audio-progress {
        position: relative;
        width: 130px;
        height: 10px;
        background-color: darken($lightgreen, 20);
        cursor: pointer;
        .progress {
          height: 10px;
          position: relative;
          background-color: $lightgreen;
        }
        .progress-hover {
          position: absolute;
          top: 0;
          height: 10px;
          background-color: lighten($lightgreen, 50);
          width: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/GlobalAudioPlayer.vue